import { useEffect } from 'react';

const MOBILE_QUERY = '(max-width: 900px), (hover: none), (pointer: coarse)';

/** Mobile zoom belongs to the editor cameras, never to the browser page. */
export default function useMobilePageZoomGuard() {
  useEffect(() => {
    const query = window.matchMedia?.(MOBILE_QUERY);
    // Modern browsers use CSS without waiting on JS for each scrolling frame.
    const needsTouchFallback = !window.CSS?.supports?.('touch-action','pan-x pan-y');
    const preventGesture = event => {
      if (query?.matches && event.cancelable) event.preventDefault();
    };
    const preventTouchZoom = event => {
      if (event.touches?.length > 1) preventGesture(event);
    };
    const preventWheelZoom = event => {
      if (event.ctrlKey || event.metaKey) preventGesture(event);
    };
    const preventKeyZoom = event => {
      if ((event.ctrlKey || event.metaKey) && ['+','=','-','_','0'].includes(event.key)) preventGesture(event);
    };
    // No stopPropagation: editor handlers still update only their own camera.
    const options = {passive:false,capture:true};
    let attached = false;
    const listen = enabled => {
      const method = enabled ? 'addEventListener' : 'removeEventListener';
      if (needsTouchFallback) document[method]('touchmove',preventTouchZoom,options);
      document[method]('gesturestart',preventGesture,options);
      document[method]('gesturechange',preventGesture,options);
      document[method]('gestureend',preventGesture,options);
      window[method]('wheel',preventWheelZoom,{passive:false});
      window[method]('keydown',preventKeyZoom);
      attached = enabled;
    };
    const update = () => {
      if (Boolean(query?.matches) !== attached) listen(Boolean(query?.matches));
    };
    update();
    query?.addEventListener?.('change',update);
    return () => {
      if (attached) listen(false);
      query?.removeEventListener?.('change',update);
    };
  }, []);
}
